"use client";
import React, { useEffect, useRef, useState } from "react";
import { Product } from "../../../payload/payload-types";
import classes from "./index.module.scss";

const SalesOffPercentage = ( product )=> {
  const { salesPrice, price } = product.product;
  if (salesPrice !== null && salesPrice) {
    let discountPrice = price - salesPrice;
    let discountPercentage = Math.ceil((discountPrice/price) * 100);
    return <span className={classes.percentageOff}>{discountPercentage}% OFF</span>;
  }
}

export default SalesOffPercentage;